// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"55a0688a","160":"8c96f6c3","208":"c6bfb8c7","293":"408b3cbf","516":"0c33f9e8","519":"eedc8599","917":"314c85ed","946":"61def8be"}[chunkId] + ".chunk.js";
};